var map = {
	"./accidental-1.png": "8485",
	"./car-1.png": "866c",
	"./disasters-1.png": "a6ab",
	"./murder-1.png": "84a0",
	"./nutrition-1.png": "733c",
	"./nutrition-2.png": "8498",
	"./nutrition-3.png": "68eb",
	"./nutrition-4.png": "d2ed",
	"./nutrition-child-1.png": "e0c8",
	"./nutrition-child-2.png": "0a21",
	"./nutrition-child-3.png": "6a77",
	"./nutrition-child-4.png": "de59",
	"./nutrition-us-1.png": "db01",
	"./terrorism-1.png": "a302",
	"./terrorism-us-1.png": "7dbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "857a";